/**
 * Support Ticket PubNub channel suffixes:
 *   external chat:  channel-{oemId}-{companyId}-{ticketId}-support
 *   internal notes: channel-{oemId}-{ticketId}-support-internal-notes
 * Work Order channels use the same shapes WITHOUT the `-support` marker, so
 * suffix inspection is the routing seam between the two modules. Check the
 * most specific suffix first when routing (`-support-internal-notes`, then
 * `-internal-notes`, then `-support`).
 */
export const SUPPORT_TICKET_EXTERNAL_CHANNEL_SUFFIX = "-support";
export const SUPPORT_TICKET_INTERNAL_NOTES_CHANNEL_SUFFIX =
  "-support-internal-notes";

export const isSupportTicketChannel = (channel?: string | null): boolean =>
  typeof channel === "string" &&
  (channel.endsWith(SUPPORT_TICKET_INTERNAL_NOTES_CHANNEL_SUFFIX) ||
    channel.endsWith(SUPPORT_TICKET_EXTERNAL_CHANNEL_SUFFIX));
